import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";




function LegislationCountry() {
  const { t } = useTranslation();


  const countries = [
    {
      name: "Bosnia and Herzegovina",
      links: [
        {
          text: t("legislation:national-strategies", "National Strategies"), linksFile: [{
            "id": 1,
            fileName: "Action plan for social inclusion of Roma in Bosnia and Herzegovina 2021-2025",
            fileLink: "legislation/Bosnia and Herzegovina/Action plan for social inclusion of Roma in Bosnia and Herzegovina 2021-2025.pdf"
          },
          {
          "id": 2,
          "fileName": "Strategija za resavanje pitanja Roma u Bosni i Hercegovini",
          "fileLink": "legislation/Bosnia and Herzegovina/Strategija za resavanje pitanja Roma u Bosni i Hercegovini.pdf"
        },
          {
            "id": 2,
            fileName: "Strategy for Roma inclusion in Bosnia and Herzegovina",
            fileLink: "legislation/Bosnia and Herzegovina/Strategy for Roma inclusion in Bosnia and Herzegovina.pdf"
          }
          ]
        },
      ],
    },
    {
      name: "Kosovo",
      links: [
        {
          text: t("legislation:national-strategies", "National Strategies"), path: "/", linksFile: [
            {
              "id": 1,
              "fileName": "Strategjia-per-avansimin-e-te-drejtave-te-komuniteteve-rom-dhe-ashkali-ne-Republiken-e-Kosoves-2022-2026-dhe-Plani-i-veprimit-2022-2024 - Albanian",
              "fileLink": "legislation/Kosovo/Strategjia-per-avansimin-e-te-drejtave-te-komuniteteve-rom-dhe-ashkali-ne-Republiken-e-Kosoves-2022-2026-dhe-Plani-i-veprimit-2022-2024.pdf"
            },
            {
              "id": 2,
              "fileName": "Strategy-for-Advancing-the-Rights-of-the-Roma-and-Ashkali-communities-in-the-Republic-of-Kosovo-for-the-period-2022-2026-and-its-Action-Plan-for-the-period-of-2022-2024 English",
              "fileLink": "legislation/Kosovo/Strategy-for-Roma-and-Ashkali-communities-of-Kosovo-for-the-period-2022-2026-and-Action-Plan-for-the-period-of-2022-2024-English.pdf"
            }
          ]
        },
      ],
    },
    {
      name: "Montenegro",
      links: [
        {
          text: t("legislation:national-strategies", "National Strategies"), path: "/", linksFile: [
            {
              "id": 1,
              "fileName": "Izvještaj o realizaciji Akcionog plana za 2023 za sjednicu KEP (002)",
              "fileLink": "legislation/Montenegro/Izvještaj o realizaciji Akcionog plana za 2023 za sjednicu KEP (002).pdf"
            },
            {
              "id": 2,
              "fileName": "strategija-socijalne-inkluzije-roma-i-egipcana-u-cg-2021-2025-sa-ap-za-2021 (4)",
              "fileLink": "legislation/Montenegro/strategija-socijalne-inkluzije-roma-i-egipcana-u-cg-2021-2025-sa-ap-za-2021 (4).pdf"
            }
          ]
        },
      ],
    },
    {
      name: "North Macedonia",
      links: [
        {
          text: t("legislation:national-strategies", "National Strategies"), path: "/", linksFile: 
            [
              {
                "id": 1,
                "fileName": "Strategy for inclusion of Roma 2022-2030 final version",
                "fileLink": "legislation/Macedonia/Strategy for inclusion of Roma 2022-2030 final version.pdf"
              },
              {
                "id": 2,
                "fileName": "НАП Антициганизам",
                "fileLink": "legislation/Macedonia/НАП Антициганизам.pdf"
              },
              {
                "id": 3,
                "fileName": "НАП Вработување и социјална инклузија",
                "fileLink": "legislation/Macedonia/НАП Вработување и социјална инклузија.pdf"
              },
              {
                "id": 4,
                "fileName": "НАП Граѓанска регистарција (1)",
                "fileLink": "legislation/Macedonia/НАП Граѓанска регистарција (1).pdf"
              },
              {
                "id": 5,
                "fileName": "НАП Граѓанска регистарција",
                "fileLink": "legislation/Macedonia/НАП Граѓанска регистарција.pdf"
              },
              {
                "id": 6,
                "fileName": "НАП Домување",
                "fileLink": "legislation/Macedonia/НАП Домување.pdf"
              },
              {
                "id": 7,
                "fileName": "НАП Здравство",
                "fileLink": "legislation/Macedonia/НАП Здравство.pdf"
              },
              {
                "id": 8,
                "fileName": "НАП Култура",
                "fileLink": "legislation/Macedonia/НАП Култура.pdf"
              }
              ,
              {
                "id": 9,
                "fileName": "НАП Образование",
                "fileLink": "legislation/Macedonia/НАП Образование.pdf"
              }
            
          ]
        },
      ],
    },
    {
      name: "Serbia",
      links: [
        {
          text: t("legislation:national-strategies", "National Strategies"), path: "/", linksFile: [
            {
              "id": 1,
              "fileName": "Strategija za socijalno ukljucivanje Roma i Romkinja 2022-2030 Srbija",
              "fileLink": "legislation/Serbia/Strategija za socijalno ukljucivanje Roma i Romkinja 2022-2030 Srbija.pdf"
            },
            {
              "id": 2,
              "fileName": "Strategy for inclusion of Roma 2022-2030 Serbia",
              "fileLink": "legislation/Serbia/Strategy for inclusion of Roma 2022-2030 Serbia.pdf"
            }
          ]
        },
      ],
    },
  ];

  const basePath = window.location.hostname === 'localhost' ? "https://localhost:9111/" : "https://roma.ivote.mk/";

  return (
    <section className="legislation-country">
      <div>
        <div className="legislation-design"></div>
      </div>
      <Accordion defaultActiveKey="0" className="w-100">
        {countries.map((country, index) => (
          <Accordion.Item eventKey={String(index)} key={index}>
            <Accordion.Header>{country.name}</Accordion.Header>
            <Accordion.Body>
              <Accordion className="sub-accordian" >
                {country.links.map((link, linkIndex) => (
                  <Accordion.Item className="sub-accordian-item" eventKey={String(linkIndex)} key={linkIndex}>
                    <Accordion.Header className="sub-accordian-title">{link.text}</Accordion.Header>
                   { link?.linksFile && <Accordion.Body >
                      {link.linksFile?.map(data => {
                        return <><div className="sub-accordian-link" onClick={() =>
                          window.open(basePath + data.fileLink, "_blank")}>● &nbsp;{data.fileName}</div></>
                      })}

                    </Accordion.Body>}
                  </Accordion.Item>
                ))}
              </Accordion>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </section>
  );
}

export default LegislationCountry;
